<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" /><span v-if="languagezh_cn" style="color:red;float:left;transform: translate(306px, -18px);font-size:12px">（标*为必填项）</span>
        <el-form  label-width="80px" class="info-form" :model="supplierForm" :rules="supplierFormRules" ref="supplierFormRef">
          <el-form-item :label="$t('page.supInfo.contentLabel.supName')" label-width="402px" prop="supplierName">     <!-- 供应商名称 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.supName')" v-model="supplierForm.supplierName" disabled class="supName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.abbreviation')" label-width="402px" prop="abbreviation">     <!-- 简称 -->
            <!--<el-input :placeholder="$t('page.supInfo.inputPlc.abbreviation')" v-model="supplierForm.abbreviation" :disabled="isSkyEyes1"></el-input>-->
            <el-input :placeholder="$t('page.supInfo.inputPlc.abbreviation')" v-model="supplierForm.abbreviation" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item v-if="languagezh_cn" :label="$t('page.supInfo.contentLabel.hisName')" label-width="402px" >     <!-- 历史名称 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.hisName')" v-model="supplierForm.supHistoryName" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item v-show="languagezh_cn&&!isWhite&&!isHaiwaiorGAT&&!isGAT" label="登记状态：" label-width="402px" >     <!-- 登记状态 -->
            <el-input v-model="supplierForm.recordStatus" maxlength="100" :disabled="!isWhite&&!isGAT&&languagezh_cn" placeholder="请输入登记状态"></el-input>
          </el-form-item>
          <el-form-item v-show="languagezh_cn&&!isWhite&&!isHaiwaiorGAT&&!isGAT" label="经营状态：" label-width="402px" >     <!-- 经营状态 -->
            <el-input v-model="supplierForm.businessStatus" maxlength="100" :disabled="!isWhite&&!isGAT&&languagezh_cn" placeholder="请输入经营状态"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.supType')" label-width="402px" class="supplierType" required>     <!-- 供应商类型 -->
            <el-col :span="5">
              <el-form-item prop="value1">
                <el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.value1">
                  <el-option
                    v-for="item in supplierForm.supplierType1"
                    :key="item.dicKey"
                    :label="isChinese === 'zh-cn'?item.dicValue:isChinese === 'en-gb'?item.dicEn:isChinese === 'es-es'?item.dicSp:isChinese === 'ru-ru'?item.dicRu:isChinese === 'fr-fr'?item.dicFr:item.dicAr"
                    :value="item.dicKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="value2">
                <el-tooltip
                  placement="top"
                  effect="light"
                  :content="getMutipleLableContent"
                  :disabled="multipleContentTipsDisabled"
                >
                  <el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.value2" class="supplierType-two" multiple clearable collapse-tags>
                  <el-option
                    v-for="item in supplierForm.supplierType2"
                    :key="item.dicKey"
                    :label="isChinese === 'zh-cn'?item.dicValue:isChinese === 'en-gb'?item.dicEn:isChinese === 'es-es'?item.dicSp:isChinese === 'ru-ru'?item.dicRu:isChinese === 'fr-fr'?item.dicFr:item.dicAr"
                    :value="item.dicKey"
                    :disabled="isMutexVals(supplierForm.value2, item.dicKey, ['1', '2'])"
                  >
                  </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.isForeign')" label-width="402px" prop="isForeignSupplier" v-if="threeZ">     <!-- 是否为外贸供应商 -->
            <el-radio-group v-model="supplierForm.isForeignSupplier">
              <el-radio :label="1">{{$t('page.supInfo.inputPlc.yes')}}</el-radio>
              <el-radio :label="0">{{$t('page.supInfo.inputPlc.no')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.isInside')" label-width="402px" prop="isInside">     <!-- 是否为晋能控股内部单位 -->
            <el-radio-group v-model="supplierForm.isInside">
              <el-radio :label="1">{{$t('page.supInfo.inputPlc.yes')}}</el-radio>
              <el-radio :label="0">{{$t('page.supInfo.inputPlc.no')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.isThree')" label-width="402px" prop="isThree" v-if="threeZ&&!isGAT">      <!-- 是否三证合一 -->
            <el-radio-group v-model="supplierForm.isThree" @change="changeRadio" disabled>
              <el-radio :label="1">{{$t('page.supInfo.inputPlc.yes')}}</el-radio>
              <el-radio :label="0">{{$t('page.supInfo.inputPlc.no')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.unifyCode')" label-width="402px" v-if="isShow && threeZ&&!isGAT" prop="creditCode" :rules="!isWhite&&!isHaiwaiorGAT?supplierFormRules.creditCode:supplierFormRules.creditCode2" ref="isShowRef" class="creditCode">     <!-- 统一社会信用代码 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.unifyCode')" v-model="supplierForm.creditCode" :disabled="!isWhite&&!isGAT&&languagezh_cn" show-word-limit  maxlength="18"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.GATunifyCode')" label-width="402px" v-if="isShow && threeZ&&isGAT" prop="creditCode" :rules="supplierFormRules.GATcreditCode" ref="isShowRef" class="creditCode endItem">     <!-- 统一社会信用代码 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.GATunifyCode')" v-model="supplierForm.creditCode" disabled show-word-limit  maxlength="75" class="GATcreditCode" :title="supplierForm.creditCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.country')" label-width="402px" v-if="!threeZ" prop="country">
            <el-cascader
              v-model="supplierForm.country"
              :props="countryProps"
              clearable
              ref="myCascader"
              @change="handleChange"
              :placeholder="locationNames?locationNames:$t('page.supInfo.inputPlc.country')">
            </el-cascader>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.unitCategory')" label-width="402px" prop="unitCategory" v-if="!threeZ">      <!-- 单位类别 -->
            <el-radio-group v-model="supplierForm.unitCategory" @change="changeUnitCategoryRadio" >
              <el-radio :label="0">{{$t('page.supInfo.inputPlc.personal')}}</el-radio>
              <el-radio :label="1">{{$t('page.supInfo.inputPlc.company')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.abroadSocialSecurity')" label-width="402px" ref="abroadSocialSecurity" class="business" v-show="!languagezh_cn&&supplierForm.unitCategory==0" prop="abroadSocialSecurity" :rules="
              (!languagezh_cn)&&isThreeShow1&&supplierForm.unitCategory==0
                ? supplierFormRules.abroadSocialSecurity
                : [{ required: false }]
            ">   <!-- 境外社保号 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.abroadSocialSecurity')" v-model="supplierForm.abroadSocialSecurity" show-word-limit  maxlength="18"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.business')" label-width="402px" ref="isThreeShowRef5" class="business" v-if="isThreeShow" prop="business"><!-- 营业执照 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.business')" v-model="supplierForm.business" show-word-limit  maxlength="20" :disabled="isSkyEyes13"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.framework')" label-width="402px" v-if="isThreeShow && threeZ" prop="organizingInstitution" ref="isThreeShowRef1" class="isThreeCode">     <!-- 组织机构代码 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.framework')" v-model="supplierForm.organizingInstitution" disabled="isSkyEyes12" show-word-limit  maxlength="18" :disabled="!isWhite&&!isGAT&&languagezh_cn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.organization')" label-width="402px" v-if="isThreeShow && threeZ" class="validity"required>     <!-- 组织机构代码证件有效期 -->
            <el-col :span="5">
              <el-form-item prop="date3" ref="isThreeShowRef2">
                <el-date-picker type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('page.supInfo.inputPlc.chooseDate')" v-model="supplierForm.date3" disabled></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="5">
              <el-form-item prop="date4" ref="isThreeShowRef3">
                <el-date-picker type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('page.supInfo.inputPlc.chooseDate')" v-model="supplierForm.date4" disabled></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.dutyParagraph')" label-width="402px" v-if="isThreeShow||!languagezh_cn" prop="dutyParagraph" ref="isThreeShowRef4" class="isThreeCode">      <!-- 税号 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.dutyParagraph')" v-model="supplierForm.dutyParagraph" :disabled="!isWhite&&!isGAT&&languagezh_cn" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.domicile')" label-width="402px" :prop="isChinese === 'zh-cn' ? 'domicile': ''">      <!-- 住所 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.domicile')" v-model="supplierForm.domicile" :disabled="!isWhite&&!isGAT&&languagezh_cn" show-word-limit maxlength="400" class="endItem" :title="supplierForm.domicile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.businessAddress')" label-width="402px" prop="businessAddress">     <!-- 办公地址 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.businessAddress')" v-model="supplierForm.businessAddress"  maxlength="200" :disabled="!isWhite&&!isGAT&&languagezh_cn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.postcode')" label-width="402px" prop="postcode" v-if="threeZ">     <!-- 邮编 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.postcode')" v-model="supplierForm.postcode" show-word-limit  maxlength="6" :disabled="!isWhite&&!isGAT&&languagezh_cn&&ygypost!==''"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.registeredCapital')" label-width="402px" prop="registeredCapital">      <!-- 注册资本(万元) -->
            <el-input v-limitdecimal.six :placeholder="$t('page.supInfo.inputPlc.registeredCapital')" v-model="supplierForm.registeredCapital" :disabled="!isWhite&&!isGAT&&languagezh_cn" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.currency')" label-width="402px" prop="value3">      <!-- 币种 -->
            <!--<el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.value3" :disabled="isSkyEyes4" filterable>-->
            <el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.value3" filterable :disabled="!isWhite&&!isGAT&&languagezh_cn">
              <el-option
                v-for="item in supplierForm.currency"
                :key="item.dicKey"
                :label="isChinese === 'zh-cn'?item.dicValue:isChinese === 'en-gb'?item.dicValue:isChinese === 'es-es'?item.dicSp:isChinese === 'ru-ru'?item.dicRu:isChinese === 'fr-fr'?item.dicFr:item.dicAr"
                :value="item.dicKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="threeZ" :label="$t('page.supInfo.contentLabel.capital')" label-width="402px" class="realCapital" prop="realCapital">       <!-- 实收资本(万元) -->
            <el-input v-limitdecimal.six :placeholder="$t('page.supInfo.inputPlc.capital')" v-model="supplierForm.realCapital" :disabled="!isWhite&&!isGAT&&languagezh_cn" maxlength="30"></el-input>
            <!-- :disabled="isSkyEyes5"-->
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.UniProperty')" label-width="402px" prop="companyPropertyName" class="companyTn" v-if="threeZ">      <!-- 单位性质 -->
            <el-input
              v-model.trim="supplierForm.companyPropertyName"
              @focus="popDialogPay()"
              :readonly="true"
              :disabled="!isWhite&&!isHaiwaiorGAT&&languagezh_cn&&supplierForm.value4"
              :placeholder="$t('page.supInfo.inputPlc.UniProperty')"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.unitCategory')" label-width="402px" prop="companyCategory" class="companyTn" v-if="threeZ">      <!-- 单位类别 -->
            <el-select  :placeholder="$t('page.supInfo.inputPlc.unitCategory')" :disabled="isQY" v-model="supplierForm.companyCategory" filterable @change="changeCompanyCategory">
              <el-option v-for="item in supplierForm.companyCategoryArr" :key="item.dicKey" :label="item.dicValue" :value="item.dicKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.companyType')" label-width="402px" prop="value4" class="companyTn" v-if="threeZ">      <!-- 公司类型 -->
            <el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.value4" filterable :disabled="!isWhite&&!isGAT&&languagezh_cn&&ygycompanyType!==''">
              <el-option v-for="item in supplierForm.companyType" :key="item.dicKey" :label="item.dicValue" :value="item.dicKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.businessScope')" label-width="402px" prop="businessScope">      <!-- 经营范围 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.input')" type="textarea" v-model="supplierForm.businessScope" show-word-limit  maxlength="1500" :disabled="!isWhite&&!isGAT&&languagezh_cn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.companyProfile')" label-width="402px" prop="companyProfile">     <!-- 公司简介 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.input')" type="textarea" v-model="supplierForm.companyProfile" show-word-limit  :maxlength="isChinese === 'zh-cn' ?500:500"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.foundingTime')" label-width="402px" :prop="isChinese === 'zh-cn' ? 'date': ''">      <!-- 成立时间 -->
            <el-date-picker
              type="date"
              :placeholder="$t('page.supInfo.inputPlc.chooseDate')"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="supplierForm.date"
              :disabled="!isWhite&&!isGAT&&languagezh_cn"
              :picker-options="pickerBeginDateBefore"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.businessTerm')" label-width="402px" class="businessTerm">     <!-- 营业期限 -->
            <el-col :span="5">
              <el-form-item prop="date1">
                <el-date-picker type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('page.supInfo.inputPlc.chooseDate')" v-model="supplierForm.date1" :picker-options="pickerOptions1" :disabled="!isWhite&&!isGAT&&languagezh_cn"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="5">
              <el-form-item prop="date2">
                <el-date-picker type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('page.supInfo.inputPlc.chooseDate')" v-model="supplierForm.date2" :picker-options="pickerOptions2" :disabled="!isWhite&&!isGAT&&languagezh_cn"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.organizationChart')" label-width="402px" :prop="isChinese === 'zh-cn' ? 'organizationChart': ''" v-if="threeZ">      <!-- 组织架构及营销网络 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.input')" type="textarea" v-model="supplierForm.organizationChart" show-word-limit  :maxlength="isChinese === 'zh-cn' ?500:1000"></el-input>
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.companyName')" label-width="402px" class="companyTn" v-if="threeZ">     <!-- 所属集团公司名称 -->
            <el-select  :placeholder="$t('page.supInfo.inputPlc.choose')" v-model="supplierForm.companyValue" @change="companyValueChange" filterable disabled>
              <el-option v-for="item in supplierForm.companyList" :key="item.supId" :label="item.supName" :value="item.supCode"></el-option>
            </el-select>
            <el-button
              type="single-number"
              class="ml10"
              @click="chooseSupplierVisible()"
              >选择</el-button
            >
            <el-button
              type="single-number"
              class="ml10"
              @click="delSupplierVisible()"
              >删除</el-button
            >
          </el-form-item>
          <el-form-item :label="$t('page.supInfo.contentLabel.organiza')" label-width="402px" prop="organizationChart" v-if="!threeZ">      <!-- 分支机构及联系方式 -->
            <el-input :placeholder="$t('page.supInfo.inputPlc.organiza')" type="textarea" v-model="supplierForm.organizationChart" show-word-limit  maxlength="500"></el-input>
          </el-form-item>
      <el-card-title :title="title1" v-if="threeZ"/>
        <el-form-item :label="$t('page.supInfo.contentLabel.capacity')" label-width="402px" :rules="supplierForm.value2.includes('1')?supplierFormRules.capacity:[{required:false}]" prop="capacity" class="capacity" v-if="threeZ">     <!-- 产能 -->
          <el-input :placeholder="$t('page.supInfo.inputPlc.input')" v-model="supplierForm.capacity" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.supInfo.contentLabel.processStatus')" label-width="402px" v-if="threeZ">     <!-- 工艺技术状况 -->
          <el-input :placeholder="$t('page.supInfo.inputPlc.input')" type="textarea" v-model="supplierForm.technicalCondition" show-word-limit  maxlength="500"></el-input>
        </el-form-item>
      <el-card-title :title="title2" v-if="threeZ"/>
        <el-form-item :label="$t('page.supInfo.contentLabel.manufacturer')" label-width="402px"  prop="producerName"  :rules="supplierForm.value2.includes('2')?supplierFormRules.producerName:[{required:false}]" class="producerName" v-if="threeZ">     <!-- 所销售产品的生产商名称 -->
          <el-input :placeholder="$t('page.supInfo.inputPlc.input')" v-model="supplierForm.producerName" maxlength="500"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.supInfo.contentLabel.qualification')" label-width="402px" v-if="threeZ">     <!-- 销售代理资格 -->
          <el-input :placeholder="$t('page.supInfo.inputPlc.input')" type="textarea" v-model="supplierForm.market" show-word-limit  maxlength="500"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t('basicLayout.btn')[1] }}</span>
      </el-button>
    </div>
    <chooseSupplier ref="chooseSupplier" @selectedSupplier="selectedSupplier"/>
    <el-dialog
      v-if="isCompanyPropertyShow"
      :visible.sync="dialogCompanyProperty"
      title="选择单位性质"
      class="dialogCompanyProperty"
      width="460px"
      append-to-body
      :before-close="beforeClose"
    >
      <div class="left-trrr">
        <div class="tree-box">
            <el-tree
              ref="dataTree"
              :data="supplierForm.companyPropertyArr"
              :props="defaultProps"
              node-key="id"
              show-checkbox
              :check-strictly='true'
              :default-expand-all='true'
              :highlight-current='true'
              @check-change="handleCheckChange"
            >
            </el-tree>
        </div>
      </div>
      <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消 </el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmForm"
          >确定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import validators from "../../../../utils/validators";
import {companyList,qrySupRegistBaseInfo,currency,saveSupplierRegistInfo,supType,qryAllDiffCounAddress,queryCompanyPropertyTree,qrySupWhiteListBySupName} from '@/api/supRegister'
import {mapActions} from 'vuex'
import Setting from "@/config/index";
import Cookies from "js-cookie";
import chooseSupplier from "../components/singleSupplier";
const savedLocaleKey = Setting.i18n.cookieLable;
export default {
  name: "basicInformation",
  data() {
    return {
      pickerBeginDateBefore: {
          disabledDate(time) {
            console.log((new Date()).valueOf())
              return time.getTime() > (new Date()).valueOf();
          }
      },
      title: window.$t('page.supInfo.contentTitle.basicInfo'),     // 基本信息
      title1: window.$t('page.supInfo.contentTitle.producer'),     // 生产商(填写)
      title2: window.$t('page.supInfo.contentTitle.dealer'),     // 经销商(填写)
      ygypost:'',
      ygycompanyType:'',
      isShow: false,
      isThreeShow: false,
      isThreeShow1: false,// 境外社保号是否显示
      belongCompanyId:'',
      threeZ: true, // 是否显示三证合一
      locationNames:"",
      isQY:false,//企业
      isWhite:false,
      isHaiwaiorGAT:false,
      isGAT:false,
      // 表单数据
      supplierForm: {
        recordStatus:'',
        businessStatus:'',
        businessStatusCode:'',
        supplierName: '',
        abbreviation: '',
        supHistoryName: '',
        isForeignSupplier: 0,
        isInside: 0,
        isThree: '',
        creditCode: '',
        business: '',
        organizingInstitution: '',
        validity: '',
        dutyParagraph: '',
        domicile: '',
        businessAddress: '',
        postcode: '',
        registeredCapital: '',
        currency: [],
        realCapital: '',
        factCaplFlag:'',
        companyType: [],
        companyPropertyArr: [],
        companyCategoryArr: [],
        businessScope: '',
        foundingTime: '',
        businessTerm: '',
        organizationChart: '',
        companyList: [],
        companyValue: '',
        companyProfile: '',
        capacity: '',
        technicalCondition: '',
        producerName: '',
        market: '',
        supplierType1: [],
        supplierType2: [],
        value1: '',
        value2: [],
        value3: window.languagezh_cn?'156':'840',
        value4: '',
        companyProperty: '',
        companyPropertyName: '',
        companyCategory: '',
        companyCategoryName: '',
        date: '',
        date1: '',
        date2: '',
        date3: '',
        date4: '',
        country: '', // 国别
        unitCategory: 0,
        abroadSocialSecurity: ''
      },
      // 表单校验规则
      supplierFormRules: {
        supplierName: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.supName'), trigger: 'blur' }],
        abbreviation: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.abbreviation'), trigger: 'blur' }],
        supHistoryName: [{ required: true, message: window.$t('page.supInfo.inputPlc.hisName'), trigger: 'blur' }],
        value1: [{ required: true, message: window.$t('page.supInfo.inputRules.supType'), trigger: 'change' }],
        value2: [{ required: true, message: window.$t('page.supInfo.inputRules.supType'), trigger: 'change' }],
        isForeignSupplier: [{ required: true, message: window.$t('page.supInfo.inputRules.choose'), trigger: 'change' },],
        isInside: [{  required: true, message: window.$t('page.supInfo.inputRules.choose'),trigger: 'change' },],
        isThree: [{  required: true, message: window.$t('page.supInfo.inputRules.choose'),trigger: 'change' },],
        creditCode: [{ required: false, message: window.$t('page.supInfo.inputPlc.unifyCode'), trigger: 'blur' }],
        creditCode2: [{ required: true, message: window.$t('page.supInfo.inputPlc.unifyCode'), trigger: 'blur' },
          {pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/, message: "请输入正确的统一社会信用代码", trigger: "blur",},
          {max: 18, min: 18, message: "请输入正确的统一社会信用代码", trigger: "blur",}],
        GATcreditCode: [{ required: true, message: "请输入港澳台统一代码证", trigger: 'blur' },
          {pattern: /^[^\u4e00-\u9fa5]+$/, message: "请输入正确的港澳台统一代码证", trigger: "blur",},
        ],
        organizingInstitution: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputPlc.framework'), trigger: 'blur' }],
        date3: [{ required: true, message: window.$t('page.supInfo.inputRules.chooseDate'), trigger: 'change' }],
        date4: [{ required: true, message: window.$t('page.supInfo.inputRules.chooseDate'), trigger: 'change' }],
        dutyParagraph: [{ required: false, message: window.$t('page.supInfo.inputPlc.dutyParagraph'), trigger: 'blur' }],
        domicile: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false, message: window.$t('page.supInfo.inputPlc.domicile'), trigger: 'blur' }],//住所
        businessAddress: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputPlc.businessAddress'), trigger: 'blur' }],//办公地址
        business: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.business'), trigger: 'blur' }],
        postcode: [{ required: true, message: window.$t('page.supInfo.inputPlc.postcode'), trigger: 'blur' },
          {max:6,message: window.$t('page.supInfo.inputRules.max'),trigger: 'blur'},
          {validator:validators.stamp,message: window.$t('page.supInfo.inputRules.postcode'),trigger: 'blur'}],
        registeredCapital: [
          {
            required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false,
            message: window.$t('page.supInfo.inputPlc.registeredCapital'),
            trigger: 'blur'
          },
          {
            validator:validators.number6,trigger:'blur'
          }
        ],
        value3: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputRules.chooseCurrency'), trigger: 'change' }],//币种
        value4: [{ required: true, message: window.$t('page.supInfo.inputRules.conpanyType'), trigger: 'change' }],
        companyPropertyName: [{ required: true, message: "请选择单位性质", trigger: 'change' }],
        companyCategory: [{ required: true, message: "请选择单位类别", trigger: 'change' }],
        realCapital: [
          {trigger: 'blur',
          required: false},
          {validator:validators.number6,trigger:'blur'}
        ],
        businessScope: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false, message: window.$t('page.supInfo.inputRules.businessScope'), trigger: 'blur' }],
        date: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT||this.isHaiwaiorGAT)?true:false, message: window.$t('page.supInfo.inputRules.foundingTime'), trigger: 'blur' }],//成立时间
        // date1: [{ required: true, message: window.$t('page.supInfo.inputRules.businessTerm'), trigger: 'blur' }],
        // date2: [{ required: true, message: window.$t('page.supInfo.inputRules.businessTerm'), trigger: 'blur' }],
        organizationChart: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputRules.organizationChart'), trigger: 'blur' }],
        companyProfile: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputRules.companyProfile'), trigger: 'blur' }],
        capacity: [{required:true,message:'请填写产能',trigger:'blur'}],
        producerName: [{required:true,message:'请填写所销售产品的生产商',trigger:'blur'}],
        country: [
          {
            required:true,
            message: window.$t('page.supInfo.inputRules.country'),
            trigger: 'change'
          },
          { validator: validators.country, trigger: "change" }
        ],
        unitCategory:[{  required: true, message: window.$t('page.supInfo.inputRules.unitCategoryType'),trigger: 'change' }],
        abroadSocialSecurity: [{required:true,message: window.$t('page.supInfo.inputRules.abroadSocialSecurity'),trigger:'blur'}],
      },
      capacityRequired: false,
      producerNameRequired: false,
      supInfoApplyId: '',
      isSkyEyes1: false,  // 是否天眼查
      isSkyEyes2: false,  // 是否天眼查
      isSkyEyes3: false,  // 是否天眼查
      isSkyEyes4: false,  // 是否天眼查
      isSkyEyes5: false,  // 是否天眼查
      isSkyEyes6: false,  // 是否天眼查
      isSkyEyes7: false,  // 是否天眼查
      isSkyEyes8: false,  // 是否天眼查
      isSkyEyes9: false,  // 是否天眼查
      // 国别参数
      countryProps: {
        label: Cookies.get(savedLocaleKey) === 'zh-cn'? "addressName": Cookies.get(savedLocaleKey) === 'en-gb'?'addressEnName':Cookies.get(savedLocaleKey) === 'es-es'?'':Cookies.get(savedLocaleKey) === 'fr-fr'?'addressFr':Cookies.get(savedLocaleKey) === 'ru-ru'?'addressRu':Cookies.get(savedLocaleKey) === 'ar'?'addressAr':'',
        value: "addressCode",
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            qryAllDiffCounAddress({ parentCode: "00" }).then(res => {
              if (res.data.code === "0") {
                res.data.data.map(item => {
                  if(item.addressCode=='702'){
                    item.addressEnName='The United Nations and its affiliated agencies and other international organizations'
                  }
                });
                resolve(res.data.data);
              }
            });
          } else {
            qryAllDiffCounAddress({ parentCode: node.data.addressCode }).then(
              res => {
                if (res.data.code === "0") {
                  res.data.data.map(item => {
                    if(item.addressCode=='702'){
                      item.addressEnName='The United Nations and its affiliated agencies and other international organizations'
                    }
                    item.leaf = item.lastFlag === 1;
                  });
                  resolve(res.data.data);
                }
              }
            );
          }
        }
      },
      countryCodes: '', // 国别编码
      countryNames: '', // 国别名称
      isChinese: (Cookies.get(savedLocaleKey) === 'zh-cn' || Cookies.get(savedLocaleKey) === undefined) ? 'zh-cn' : Cookies.get(savedLocaleKey),
      defaultProps: {
        children: 'childNode',
        label: 'dicValue',
        isLeaf: "isLeaf"
      },
      dialogCompanyProperty: false,
      isCompanyPropertyShow: false,
      selectData: {} //单位性质树
    }
  },
  components: {
    chooseSupplier
  },
  computed: {
    pickerOptions1() {
      let that = this;
      return {
        disabledDate: function(time) {
          if (that.supplierForm.date2) {
            return time.getTime() > new Date(that.supplierForm.date2).getTime()
          } else {
            return false;
          }
        }
      }
    },
    pickerOptions2() {
      let that = this;
      return {
        disabledDate: function(time) {
          if (that.supplierForm.date1) {
            return time.getTime() < new Date(that.supplierForm.date1).getTime()
          } else {
            return false;
          }
        }
      }
    },
    supSupTypeBOList() {
      const langMap = {
        'zh-cn': 'dicValue',
        'en-gb': 'dicEn',
        'es-es': 'dicSp',
        'ru-ru': 'dicRu',
        'fr-fr': 'dicAr'
      }
      if (this.supplierForm && this.supplierForm.value2.length) {
        return this.supplierForm.value2.map(item => {
          const element = this.supplierForm.supplierType2.find(e => e.dicKey === item)
          const res = {
            supType: element.dicKey,
            supTypeName: element[langMap[Cookies.get(savedLocaleKey) || 'zh-cn']]
          }
          return res
        })
      }
      return []
    },
    multipleContentTipsDisabled() {
      return !this.supplierForm.value2 || this.supplierForm.value2.length <= 1;
    },
    getMutipleLableContent() {
      return this.supSupTypeBOList.map(item => item.supTypeName).join('/')
    }
  },
  created() {
    this.getCompanyList()
    this.getCurrency()
    this.getSupType2()
    if(Cookies.get(savedLocaleKey) === 'zh-cn') {
      this.getSupType1()
    } else {
      this.getSupType3()
    }
    this.getCompanyProperty();
    this.getCompanyCategory();
    this.getCompany();
    if(Cookies.get('access_token') || this.$route.query.tempSupinfoId){
      this.getSupRegistBaseInfo()
    }
    if(this.$route.path == '/maPerfectInfo/basicInformation'){
      this.changeCheckPage(4)
      this.msgCenter.$emit('ballMoveRight')
    }
    if(this.$route.query.page) {
      this.changeCheckPage(4)
    }
  },
  mounted() {
    if(Cookies.get(savedLocaleKey) === 'zh-cn' ) {
      this.threeZ = true
    } else {
      this.threeZ = false
      this.isShow = false
      this.isThreeShow = false
      if(this.supplierForm.unitCategory === 0) {
        this.isThreeShow1 = true
      } else {
        this.isThreeShow1 = false
      }
    }
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    back() {
     this.changeCheckPage(3)
      this.$router.push({path:'/maPerfectInfo/applyUsername',query:{tempSupinfoId: this.$route.query.tempSupinfoId, v:Math.random()}})
    },
    next() {
      this.$refs.supplierFormRef.validate(async valid => {
        if(valid) {
           try {
            let isTreeObj=  {};
            if(!this.supplierForm.isThree){
              isTreeObj = {
                orgCode :this.supplierForm.organizingInstitution,
                orgCredentialsStart : this.supplierForm.date3,
                orgCredentialsEnd : this.supplierForm.date4,
              }
            }
            console.log(this.supplierForm.supplierName, 'supplierName')
            if(this.languagezh_cn){
              await this.$confirm (
                "当前页面展示字段为系统自动关联带出的信息，请您逐一检查（如经营状态、单位性质等关键信息）是否正确，若发现错误可及时联系400-903-0036",
                "提示",
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "确定",
                  customClass: "ccui-message-box-custom",
                  showCancelButton: false,
                  closeOnClickModal: false
                }
              ).then(() => {});
            }
             const {data} = await saveSupplierRegistInfo({
               dataSourceFlag: 0,
               isOverseas: this.threeZ?0:1,
               tempSupinfoId: this.supInfoApplyId,
               saveOrCommitFlag: '2',
               supRegistTab: '5',
               isShowLoading:true,
               supRegistAccountInfoBO: {
                //  regNum: this.threeZ && this.isThreeShow1 === false ? this.supplierForm.business : this.supplierForm.abroadSocialSecurity,
                regNum:(!window.languagezh_cn)? this.supplierForm.business:this.threeZ && this.isThreeShow1 === false ? this.supplierForm.business : this.supplierForm.creditCode,
                 taxCode: this.supplierForm.dutyParagraph,
                 supplierName:this.supplierForm.supplierName,
                 supName:this.supplierForm.supplierName,
                 isCredentials:this.supplierForm.isThree,
                 countyCode:sessionStorage.getItem('countyCode'),
                 countyName:sessionStorage.getItem('countyName'),
                 locationCode:
                   this.countryCodes && this.countryCodes[0]
                     ? this.countryCodes[0]
                     : (this.supplierForm.locationCode||""), //   第一级
                 ...isTreeObj
               },
               supRegistBaseInfoBO: {
                 recordStatus:this.supplierForm.recordStatus,
                 businessStatusCode:this.supplierForm.businessStatusCode,
                 businessStatus:this.supplierForm.businessStatus,
                 socialSecurityNumber:!this.languagezh_cn?this.supplierForm.abroadSocialSecurity:"",
                 supShort: this.supplierForm.abbreviation,
                 supHistoryName: this.supplierForm.supHistoryName,
                 supMatType: this.supplierForm.value1,
                //  supType: this.supplierForm.value2,
                 isOutSup: this.supplierForm.isForeignSupplier,
                 isInIndy: this.supplierForm.isInside,
                 homeAddr: this.supplierForm.domicile,
                 officeAddr: this.supplierForm.businessAddress,
                 post: this.supplierForm.postcode,
                 regCapl: this.supplierForm.registeredCapital,
                 moneyType: this.supplierForm.value3,
                 factCapl: this.supplierForm.realCapital,
                 companyType: this.threeZ ? this.supplierForm.value4 : this.supplierForm.unitCategory,
                 companyProperty: this.supplierForm.companyProperty,
                 companyPropertyName: this.supplierForm.companyPropertyName,
                 companyCategory: window.languagezh_cn?this.supplierForm.companyCategory:this.supplierForm.unitCategory==1?"B1":"B2",
                 companyCategoryName: window.languagezh_cn?this.supplierForm.companyCategoryName:this.supplierForm.unitCategory==1?"单位":"个人",
                 foundTime: this.supplierForm.date,
                 businessStart: this.supplierForm.date1,
                 businessEnd: this.supplierForm.date2,
                 belongCompanyName: this.supplierForm.companyValue,
                 capacity: this.supplierForm.capacity?this.supplierForm.capacity:'',
                 belongCompanyId: this.belongCompanyId,
                 supSupTypeBOList: this.supSupTypeBOList, // 供应商二级分类
                 locationCode:
                   this.countryCodes && this.countryCodes[0]
                     ? this.countryCodes[0]
                     : (this.supplierForm.locationCode||""), //   第一级
                 locationName:
                   this.countryNames && this.countryNames[0]
                     ? this.countryNames[0]
                     : (this.supplierForm.locationName||""), //
                 countryCode:
                   this.countryCodes && this.countryCodes[0]
                     ? this.countryCodes[1]
                     : (this.supplierForm.countryCode||""), //    第二级
                 countryName:
                   this.countryNames && this.countryNames[0]
                     ? this.countryNames[1]
                     : (this.supplierForm.countryName||""), //国别
               },
               supRegistTextInfoBO: {
                 busiScope: this.supplierForm.businessScope,
                 orgStructMarketNet: this.supplierForm.organizationChart,
                 companyProfile: this.supplierForm.companyProfile,
                 processTech: this.supplierForm.technicalCondition,
                 producerName: this.supplierForm.producerName,
                 agentQualify: this.supplierForm.market
               }
             })
             console.log(data)
             if(data.code == 0) {
               this.changeCheckPage(5)
               this.$router.push({
                 path:'/maPerfectInfo/contactInformation',
                 query: {tempSupinfoId: this.$route.query.tempSupinfoId}
               })
             } else {
                this.$message({
                  showClose: true,
                  type: "error",
                  message: data.message,
                  ccuiCustom: true,
                })
             }
           } catch (err){
             this.$message({
               showClose: true,
               type: err.data.message,
               message: data.message,
               ccuiCustom: true,
             })
             console.log(err.data.message)
           }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName('is-error');
            isError[0].querySelector('input').focus();
          },100)
          return false
        }
      })
    },
    changeRadio(val) {
      // console.log(val)
      if(val===1) {
        this.isShow = true
        this.isThreeShow = false
        this.$refs.isThreeShowRef1.resetField()
        this.$refs.isThreeShowRef2.resetField()
        this.$refs.isThreeShowRef3.resetField()
        this.$refs.isThreeShowRef4.resetField()
        console.log(this.isShow)
      } else if (val===0) {
        this.isThreeShow = true
        this.isShow = false
        this.$refs.isShowRef.resetField()
      }
    },
    changeUnitCategoryRadio(val) {
      if(val===1) {
        this.isThreeShow1 = false
        this.$refs.abroadSocialSecurity.resetField()
      } else if (val===0) {
        this.isThreeShow1 = true
        this.supplierForm.business = ""
      }
    },
    // 获取所属集团公司列表
    async getCompanyList() {
      try{
        const {data} = await companyList({
          abroadFlag: '0'
        })
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.companyList = data.data.rows
        }
      } catch (err) {
        console.log('获取失败')
      }
    },
    // 获取供应商注册申请账户的信息
    async getSupRegistBaseInfo() {
      try {
        const {data} = await qrySupRegistBaseInfo({
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading:true
        })
        console.log(data)
        if(data.data.supRegistAccountInfoBO.locationCode=='970000'){
          this.isGAT=true
          this.supplierForm.locationCode=data.data.supRegistAccountInfoBO.locationCode
        }
        qrySupWhiteListBySupName({
          supName:data.data.supRegistAccountInfoBO.supName
        }).then(obj=>{
          if(obj.data.data.rows.length>0){
            this.isWhite=true
          }else{
            this.isWhite=false
          }
          if(data.data.supRegistAccountInfoBO.locationCode=='980000'){//地址海外 输入框校验逻辑和白名单一致，所以这里处理成白名单
            this.isWhite=true
          }
          this.supplierFormRules= {
            supplierName: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.supName'), trigger: 'blur' }],
              abbreviation: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.abbreviation'), trigger: 'blur' }],
              supHistoryName: [{ required: true, message: window.$t('page.supInfo.inputPlc.hisName'), trigger: 'blur' }],
              value1: [{ required: true, message: window.$t('page.supInfo.inputRules.supType'), trigger: 'change' }],
              value2: [{ required: true, message: window.$t('page.supInfo.inputRules.supType'), trigger: 'change' }],
              isForeignSupplier: [{ required: true, message: window.$t('page.supInfo.inputRules.choose'), trigger: 'change' },],
              isInside: [{  required: true, message: window.$t('page.supInfo.inputRules.choose'),trigger: 'change' },],
              isThree: [{  required: true, message: window.$t('page.supInfo.inputRules.choose'),trigger: 'change' },],
              creditCode: [{ required: false, message: window.$t('page.supInfo.inputPlc.unifyCode'), trigger: 'blur' }],
            creditCode2: [{ required: true, message: window.$t('page.supInfo.inputPlc.unifyCode'), trigger: 'blur' },
              {pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/, message: "请输入正确的统一社会信用代码", trigger: "blur",},
              {max: 18, min: 18, message: "请输入正确的统一社会信用代码", trigger: "blur",}],
              GATcreditCode: [{ required: true, message: "请输入港澳台统一代码证", trigger: 'blur' },
              {pattern: /^[^\u4e00-\u9fa5]+$/, message: "请输入正确的港澳台统一代码证", trigger: "blur",},
            ],
              organizingInstitution: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputPlc.framework'), trigger: 'blur' }],
              date3: [{ required: true, message: window.$t('page.supInfo.inputRules.chooseDate'), trigger: 'change' }],
              date4: [{ required: true, message: window.$t('page.supInfo.inputRules.chooseDate'), trigger: 'change' }],
              dutyParagraph: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false, message: window.$t('page.supInfo.inputPlc.dutyParagraph'), trigger: 'blur' }],
              domicile: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false, message: window.$t('page.supInfo.inputPlc.domicile'), trigger: 'blur' }],//住所
              businessAddress: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputPlc.businessAddress'), trigger: 'blur' }],//办公地址
              business: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputPlc.business'), trigger: 'blur' }],
              postcode: [{ required: true, message: window.$t('page.supInfo.inputPlc.postcode'), trigger: 'blur' },
              {max:6,message: window.$t('page.supInfo.inputRules.max'),trigger: 'blur'},
              {validator:validators.stamp,message: window.$t('page.supInfo.inputRules.postcode'),trigger: 'blur'}],
              registeredCapital: [
              {
                required: window.languagezh_cn&&(this.isWhite||this.isGAT)?true:false,
                message: window.$t('page.supInfo.inputPlc.registeredCapital'),
                trigger: 'blur'
              },
              {
                validator:validators.number6,trigger:'blur'
              }
            ],
              value3: [{ required: window.languagezh_cn&&!this.isWhite&&!this.isGAT?false:true, message: window.$t('page.supInfo.inputRules.chooseCurrency'), trigger: 'change' }],//币种
              value4: [{ required: true, message: window.$t('page.supInfo.inputRules.conpanyType'), trigger: 'change' }],
              companyPropertyName: [{ required: true, message: "请选择单位性质", trigger: 'change' }],
              companyCategory: [{ required: true, message: "请选择单位类别", trigger: 'change' }],
              realCapital: [
              {trigger: 'blur',
                required: false},
              {validator:validators.number6,trigger:'blur'}
            ],
              businessScope: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT||this.isHaiwaiorGAT)?true:false, message: window.$t('page.supInfo.inputRules.businessScope'), trigger: 'blur' }],
              date: [{ required: window.languagezh_cn&&(this.isWhite||this.isGAT||this.isHaiwaiorGAT)?true:false, message: window.$t('page.supInfo.inputRules.foundingTime'), trigger: 'blur' }],//成立时间
              // date1: [{ required: true, message: window.$t('page.supInfo.inputRules.businessTerm'), trigger: 'blur' }],
              // date2: [{ required: true, message: window.$t('page.supInfo.inputRules.businessTerm'), trigger: 'blur' }],
              organizationChart: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputRules.organizationChart'), trigger: 'blur' }],
              companyProfile: [{ required: window.languagezh_cn?true:false, message: window.$t('page.supInfo.inputRules.companyProfile'), trigger: 'blur' }],
              capacity: [{required:true,message:'请填写产能',trigger:'blur'}],
              producerName: [{required:true,message:'请填写所销售产品的生产商',trigger:'blur'}],
              country: [
                {
                  required: true,
                  message: window.$t('page.supInfo.inputRules.country'),
                  trigger: 'change'},
                {
                  validator: validators.country,
                  trigger: "change"
                }
              ],
              unitCategory:[{  required: true, message: window.$t('page.supInfo.inputRules.unitCategoryType'),trigger: 'change' }],
              abroadSocialSecurity: [{required:true,message: window.$t('page.supInfo.inputRules.abroadSocialSecurity'),trigger:'blur'}],
          }
        })
        if(data.code === '0') {
          sessionStorage.setItem('countyCode',data.data.supRegistAccountInfoBO.countyCode)
          sessionStorage.setItem('countyName',data.data.supRegistAccountInfoBO.countyName)
          if(data.data.supRegistAccountInfoBO.isCredentials + '' === '1') {
            this.isShow = true//统一信用带啊
            this.isThreeShow = false//营业执照等
          } else if (data.data.supRegistAccountInfoBO.isCredentials + '' === '0') {
            this.isShow = false
            this.isThreeShow = true
            this.supplierForm.business=data.data.supRegistAccountInfoBO.regNum
          }
          this.supplierForm.creditCode = data.data.supRegistAccountInfoBO.regNum

          this.supplierForm.unitCategory = data.data.isOverseas==1?data.data.supRegistBaseInfoBO.companyCategory=='B2'?0:1:Number(data.data.supRegistBaseInfoBO.companyType)
          if(Number(data.data.supRegistBaseInfoBO.companyType) === 0||this.supplierForm.unitCategory===0) {
            this.isThreeShow1 = true
            this.supplierForm.abroadSocialSecurity = data.data.supRegistAccountInfoBO.regNum
          } else {
            this.isThreeShow1 = false
            this.supplierForm.business = data.data.supRegistAccountInfoBO.regNum
          }
          this.supplierForm.country = [data.data.supRegistBaseInfoBO.locationCode,data.data.supRegistBaseInfoBO.countryCode]
          console.log("结果",this.supplierForm.country)
          if((!window.languagezh_cn)){
            this.supplierForm.countryCode=data.data.supRegistBaseInfoBO.countryCode
            this.supplierForm.countryName=data.data.supRegistBaseInfoBO.countryName
            this.supplierForm.locationCode=data.data.supRegistBaseInfoBO.locationCode
            this.supplierForm.locationName=data.data.supRegistBaseInfoBO.locationName
          }
          this.supplierForm.supplierName = data.data.supRegistAccountInfoBO.supName
          this.supplierForm.isThree = data.data.supRegistAccountInfoBO.isCredentials
          this.supplierForm.organizingInstitution = data.data.supRegistAccountInfoBO.orgCode
          this.supplierForm.date3 = data.data.supRegistAccountInfoBO.orgCredentialsStart
          this.supplierForm.date4 = data.data.supRegistAccountInfoBO.orgCredentialsEnd
          this.supplierForm.dutyParagraph = data.data.supRegistAccountInfoBO.taxCode
          this.supplierForm.abbreviation = data.data.supRegistBaseInfoBO.supShort
          this.supplierForm.supHistoryName = data.data.supRegistBaseInfoBO.supHistoryName
          this.supplierForm.value1 = data.data.supRegistBaseInfoBO.supMatType
          this.supplierForm.value2 = data.data.supRegistBaseInfoBO.supSupTypeBOList.map(item => item.supType).filter(item => !!item)
          this.supplierForm.isForeignSupplier = data.data.supRegistBaseInfoBO.isOutSup,
          this.supplierForm.isInside = data.data.supRegistBaseInfoBO.isInIndy
          this.supplierForm.domicile = data.data.supRegistBaseInfoBO.homeAddr
          this.supplierForm.businessAddress = data.data.supRegistBaseInfoBO.officeAddr,
          this.supplierForm.businessStatusCode = data.data.supRegistBaseInfoBO.businessStatusCode,
          this.supplierForm.businessStatus = data.data.supRegistBaseInfoBO.businessStatus,
          this.supplierForm.recordStatus = data.data.supRegistBaseInfoBO.recordStatus,
          this.supplierForm.postcode = data.data.supRegistBaseInfoBO.post||data.data.supRegistAccountInfoBO.post
          this.ygypost=data.data.supRegistBaseInfoBO.post
          this.supplierForm.registeredCapital = data.data.supRegistBaseInfoBO.regCapl
          // if(this.supplierForm.registeredCapital+'' !== '') {
          //   this.supplierFormRules.registeredCapital = []
          // }
          this.supplierForm.value3 = data.data.supRegistBaseInfoBO.moneyType.toString()
            if(!this.supplierForm.value3) {
              this.supplierForm.value3 =window.languagezh_cn? '156':'840'
            }
          this.supplierForm.realCapital = data.data.supRegistBaseInfoBO.factCapl
          this.supplierForm.factCaplFlag = data.data.supRegistBaseInfoBO.factCaplFlag
          if(this.supplierForm.realCapital+'' !== '') {
            this.supplierFormRules.realCapital = []
          }
          this.supplierForm.value4 = data.data.supRegistBaseInfoBO.companyType||data.data.supRegistAccountInfoBO.companyType
          this.ygycompanyType=data.data.supRegistBaseInfoBO.companyType
          this.supplierForm.companyProperty = data.data.supRegistBaseInfoBO.companyProperty
          this.supplierForm.companyPropertyName = data.data.supRegistBaseInfoBO.companyPropertyName
          this.supplierForm.companyCategory = data.data.supRegistBaseInfoBO.companyCategory
          this.supplierForm.companyCategoryName = data.data.supRegistBaseInfoBO.companyCategoryName
          if(data.data.supRegistAccountInfoBO.isCredentials + '' === '1'&&window.languagezh_cn&&!this.isGAT) {
            var pattern = /^(91|92)/
            if(pattern.test(this.supplierForm.creditCode)){
              this.isQY=true
              this.supplierForm.companyCategory="A11"
              this.supplierForm.companyCategoryName = '企业'
            }
          }
          this.supplierForm.date = data.data.supRegistBaseInfoBO.foundTime
          this.supplierForm.date1 = data.data.supRegistBaseInfoBO.businessStart
          this.supplierForm.date2 = data.data.supRegistBaseInfoBO.businessEnd
          this.supplierForm.companyValue = data.data.supRegistBaseInfoBO.belongCompanyName
          this.supplierForm.capacity = data.data.supRegistBaseInfoBO.capacity
          this.supplierForm.businessScope = data.data.supRegistBaseInfoBO.busiScope
          this.supplierForm.organizationChart = data.data.supRegistBaseInfoBO.orgStructMarketNet
          this.supplierForm.companyProfile = data.data.supRegistBaseInfoBO.companyProfile
          this.supplierForm.technicalCondition = data.data.supRegistBaseInfoBO.processTech
          this.supplierForm.producerName = data.data.supRegistBaseInfoBO.producerName
          this.supplierForm.market = data.data.supRegistBaseInfoBO.agentQualify
          this.supInfoApplyId = data.data.supInfoApplyId
          if(data.data.supRegistBaseInfoBO.locationName) {
            if(this.$refs.myCascader){
              this.$refs.myCascader.inputValue = `${data.data.supRegistBaseInfoBO.locationName +
              "\xa0" +
              "/" +
              "\xa0" +
              data.data.supRegistBaseInfoBO.countryName}`
            }

            this.locationNames=`${data.data.supRegistBaseInfoBO.locationName +
            "\xa0" +
            "/" +
            "\xa0" +
            data.data.supRegistBaseInfoBO.countryName}`
          }
          if((!window.languagezh_cn)&&(data.data.supRegistBaseInfoBO.socialSecurityNumber)){
            this.supplierForm.abroadSocialSecurity = data.data.supRegistBaseInfoBO.socialSecurityNumber;
          }
        }
          if(this.supplierForm.isThree === 0 ) {
              this.isShow = false
              this.isThreeShow = true
              // this.$refs.isThreeShowRef1.resetField()
              // this.$refs.isThreeShowRef2.resetField()
              // this.$refs.isThreeShowRef3.resetField()
              // this.$refs.isThreeShowRef4.resetField()
            } else if (this.supplierForm.isThree ===1) {
              this.isThreeShow = false
              this.isShow = true
              // this.$refs.isShowRef.resetField()
            }
            //控制天眼查致灰
      } catch (err) {
          console.log(err)
      }
    },
    // 获取币种列表
    async getCurrency() {
      try {
        const {data} =await currency({code:'MONEY_TYPE'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.currency = data.data
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    // 获取单位性质
    async getCompanyProperty() {
      try {
        const {data} = await queryCompanyPropertyTree({"languageFlag":"zh"})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.companyPropertyArr = data.data
          this.isLeafForEach(this.supplierForm.companyPropertyArr);
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    isLeafForEach(arr){
      arr.forEach(e=>{
        if(e.isLeaf !==1) {
            e.disabled = true;
        }
        if(e.childNode.length > 0){
          this.isLeafForEach(e.childNode)
        }
      })
    },
    popDialogPay(){
      this.dialogCompanyProperty = true;
      this.isCompanyPropertyShow = true;
    },
    beforeClose(){
      this.dialogCompanyProperty = false;
      this.isCompanyPropertyShow = false;
      this.selectData = {};
    },
    closeDialog(){
      this.dialogCompanyProperty = false;
      this.isCompanyPropertyShow = false;
      this.selectData = {};
    },
    handleCheckChange(data, checked, indeterminate){
      if (checked) {
        this.selectData = data;
        this.$refs.dataTree.setCheckedKeys([data.id])
      }
    },
    confirmForm(){
      if(this.selectData.isLeaf !==1 || this.selectData.childNode.length >0){
        //弹出提示
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择最后一级",
          ccuiCustom: true,
          duration: 3000
        });
        return
      }
      this.supplierForm.companyProperty = this.selectData.dicKey;
      this.supplierForm.companyPropertyName = this.selectData.dicValue;

      this.closeDialog();
    },
    // 获取单位类别
    async getCompanyCategory() {
      try {
        const {data} =await currency({code:'SMPC_COMPANY_CATEGORY'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.companyCategoryArr = data.data.filter(e=> e.dicKey !=="A2");
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    changeCompanyCategory(val){
      let tempObj = this.supplierForm.companyCategoryArr.find(e => {
        return e.dicKey === val;
      });
      this.supplierForm.companyCategoryName = tempObj.dicValue;
    },
    // 获取公司类型
    async getCompany() {
      try {
        const {data} =await currency({code:'GSLX'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.companyType = data.data
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    // 所属集团变化
    companyValueChange(val) {
      console.log(val)
      this.supplierForm.companyList.forEach(item => {
        if(item.supCode === val) {
          this.belongCompanyId = item.supId
          this.supplierForm.companyValue = item.supName
        }
      })
      console.log(this.belongCompanyId)
    },
    // 获取供应商类型
    async getSupType2() {
      try {
        const {data} = await supType({code:'SUP_TYPE'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.supplierType2 = data.data
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    // 获取供应商类型
    async getSupType1() {
      try {
        const {data} = await supType({code:'SUP_MAT_TYPE'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.supplierType1 = data.data
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    // 获取供应商类型
    async getSupType3() {
      try {
        let code="";
        if(this.languagezh_cn){
          code="MATERIAL_TYPE_EN"
        }else{
          code="MATERIAL_TYPE_EN"
        }
        const {data} = await supType({code:'MATERIAL_TYPE_EN'})
        console.log(data)
        if(data.code === '0') {
          this.supplierForm.supplierType1 = data.data
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    //选择国别
    handleChange(data) {
      console.log(data);
      // this.$emit(
      //   "handleChange",
      //   data,
      //   this.$refs["countryCascader"].getCheckedNodes()[0].pathLabels
      // );
      console.log(this.$refs.myCascader.getCheckedNodes()[0].pathLabels)
      this.countryCodes = data
      this.countryNames = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
      console.log(this.countryCodes)
      console.log(this.countryNames)
      console.log(this.supplierForm.country)
    },
    //所属集团公司名称
    chooseSupplierVisible(){
      this.$refs.chooseSupplier.visible = true;
      this.$refs.chooseSupplier.singleSearch();
    },
    //删除所属集团公司名称
    delSupplierVisible(){
      this.supplierForm.companyValue = ""
    },
    selectedSupplier(data){
      this.belongCompanyId = data.supId
      this.supplierForm.companyValue = data.supName
    },
    // 下拉互斥禁用状态判定
    isMutexVals(val, optionVal, mutexVals) {
      if (!val || !val.length) return false;
      if (val instanceof Array) {
        if (mutexVals.includes(optionVal)) {
          for (let i = 0; i < val.length; i++) {
            if (val[i] !== optionVal && mutexVals.includes(val[i])) {
              return true;
            }
          }
        }
        return false;
      } else {
        if (mutexVals.includes(optionVal)) {
          return val !== optionVal && mutexVals.includes(val);
        }
        return false;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.endItem ::v-deep .el-input__inner{
  padding-right: 58px;
}
  .sign-content {
    width: 1180px;
    background: #FFFFFF;
    margin: 20px auto;
    overflow: hidden;
    .el-card-title {
      /deep/ .details-title {
        color: black;
        border-bottom: 0px;
        top: 20px;
        margin-left: 230px;
      }
    }
    /deep/ .info-form {
      //margin-left: 200px;
      margin-top: 20px;
      .el-input,.el-radio-group,.el-date-editor,.el-textarea {
        width: 430px;
        margin-left: 6px;
      }
      .el-textarea {
        width: 430px;
        height: 122px;
        border-radius: 4px;
        .el-textarea__inner {
          height: 102px;
          //.el-input__count {
          //  position: absolute;
          //  right: 0px;
          //}
        }
      }
      .el-radio__input.is-checked .el-radio__inner {
        background-color: #ff142f;
        border-color: #ff142f;
      }
      .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 200px;
      }
      .el-input--suffix .el-input__inner {
        width: 200px;
      }
      .el-select>.el-input {
        width: 200px;
      }
      .el-col-24 {
        width: 10px;
        margin-left: 55px;
      }
      .companyTn .el-input {
        width: 430px;
        .el-input__inner {
          width: 430px;
        }
      }
      .realCapital .el-input {
        width: 200px;
        .el-input__inner {
          width: 200px;
        }
      }
      .supplierType .el-select {
        width: 200px;
      }
      .supplierType .supplierType-two {
        margin-left: 30px;
      }
      .businessTerm .el-col-2 {
        position: absolute;
        left: 215px;
      }
      .businessTerm .el-col-5:nth-child(3) {
        margin-left: 60px;
      }
      .supplierType .el-col-5:nth-child(2) {
        margin-left: 30px;
      }
      .validity .el-col-2 {
        position: absolute;
        left: 215px;
      }
      .validity .el-col-5:nth-child(3) {
        margin-left: 60px;
      }
      .supName {
        width: 430px;
      }
      .producerName {
        margin-top: 20px;
      }
      .creditCode .el-input {
        width: 430px;
      }
      .capacity {
        margin-top: 20px;
      }
       .el-input__inner {
        width: 430px;
      }
      .isThreeCode .el-input {
        width: 430px;
      }
      .business {
        .el-input {
          width: 430px;
        }
      }
      .el-cascader {
        .el-input__inner {
          width: 430px;
        }
      }
    }
  }
  .btn {
    width: 240px;
    height: 40px;
    background: #FF142F;
    margin-bottom: 20px;
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
    }
  }
  .btnBox {
    margin: 0px auto;
    width: 500px;
  }
  /deep/.ml10{
    margin-left: 10px;
    border-color: #FF142F;
    background: none;
    span {
      color: #FF142F;
    }
  }
  /deep/.GATcreditCode input{
    padding-right:50px
  }
/deep/.el-input.is-disabled .el-input__inner:hover::after {
  display: none;
}

</style>
<style>
  .dialogCompanyProperty{
    position:fixed!important;
  }
</style>
